import TandemCategoriesClassification from '../resources/tandem_categories.json';

class Range {
	constructor(r) {
		this.l = r[0];
		this.u = r[1];
	}

	includes(v) {
		return v >= this.l && v < this.u;
	}
}

export class TandemCategories {
	static {
		this.UUID = TandemCategoriesClassification.uuid;
		this.classificationSystem = TandemCategoriesClassification;
		this.size = this.classificationSystem.rows.length;

		this.Facility = this.code2index("L.Fa");
		this.Floors = this.code2index("B.Fl");
		this.Roofs = this.code2index("B.Ro");
		this.Ceilings = this.code2index("B.Ce");

		this.Range = {
			Building: new Range(this.code2range("B")),
			Mechanical: new Range(this.code2range("M")),
			Electrical: new Range(this.code2range("E")),
			Plumbing: new Range(this.code2range("P")),
			Equipment: new Range(this.code2range("Q")),
			Exterior: new Range(this.code2range("X")),
			Location: new Range(this.code2range("L")),
			Information: new Range(this.code2range("I")),
		}
		this.Range.MEPQ = new Range([this.Range.Mechanical.l, this.Range.Equipment.u]);
	}

	// 1-based index
	static code2index(code) {
		if(!this._code2index) {
			this._code2index = this.classificationSystem.rows.reduce((dict, row, idx) => {
				dict[row[0]] = idx+1;
				return dict;
			}, {});
		}
		return this._code2index[code] ?? 0;
	}

	static code2range(code) {
		const c = this.code2index(code);
		if(!c) {
			return [0,0];
		}

		const rows = this.classificationSystem.rows;
		let cUpper = c+1;
		for(; cUpper < rows.length; cUpper++) {
			if(!rows[cUpper][0].startsWith(code)) {
				break;
			}
		}
		return [c, cUpper];
	}

	static code2glowFlag(code) {
		const [c, cUpper] = this.code2range(code);
		return c | (cUpper << 16);
	}

	static index2code(index) {
		return this.index2row(index)?.[0]
	}

	static index2row(index) {
		return this.classificationSystem.rows[index - 1];
	}
}
